import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Actions } from '../actions';
import AllPost from '../components/Connect/AllPost';
import './App.scss';

class AllPostContainer extends Component {
    render() {
        return (
            <div>
                <AllPost allPosts={this.props.allPosts} 
                         profileInfo={this.props.profileInfo}
                         handleCreatePost={this.props.handleCreatePost}
                         handleLikePost={this.props.handleLikePost}
                         handleEditPost={this.props.handleEditPost} 
                         handleDeletePost={this.props.handleDeletePost} 
                         bookmark={this.props.bookmark}
                         handleUpdateBookmark={this.props.handleUpdateBookmark}
                         isFiltered={this.props.isFiltered}
                         filteredPosts={this.props.filteredPosts}
                         profileName={this.props.profileName}
                         kpis={this.props.kpis} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return state;
};

export default connect(mapStateToProps, Actions)(AllPostContainer);
